import type { Project } from './project';
import { getMasterProjects, getSubProjects } from './projectTree';

export interface ProjectMultimediaTarget {
  projectId: number;
}

export const resolveProjectMultimediaTarget = (
  projects: Project[],
  masterProjectId: number,
  subProjectId: number | null
): ProjectMultimediaTarget | null => {
  const masterProject = getMasterProjects(projects).find((project) => project.id === masterProjectId) ?? null;
  if (!masterProject) return null;
  if (subProjectId === null) return { projectId: masterProjectId };

  const subProject = getSubProjects(projects, masterProjectId).find(
    (project) => project.id === subProjectId && project.masterProjectId === masterProjectId
  );

  if (!subProject) return null;
  return { projectId: subProjectId };
};
